__turbopack_context__.v({
  "composition": "VisualSearchIllustration-module__A2RoIq__composition",
  "corner": "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerBottomLeft": "VisualSearchIllustration-module__A2RoIq__cornerBottomLeft" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerBottomRight": "VisualSearchIllustration-module__A2RoIq__cornerBottomRight" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerTopLeft": "VisualSearchIllustration-module__A2RoIq__cornerTopLeft" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "cornerTopRight": "VisualSearchIllustration-module__A2RoIq__cornerTopRight" + " " + "VisualSearchIllustration-module__A2RoIq__corner",
  "listingImage": "VisualSearchIllustration-module__A2RoIq__listingImage",
  "listingTitle": "VisualSearchIllustration-module__A2RoIq__listingTitle",
  "lit": "VisualSearchIllustration-module__A2RoIq__lit",
  "matchCard": "VisualSearchIllustration-module__A2RoIq__matchCard",
  "phone": "VisualSearchIllustration-module__A2RoIq__phone",
  "photo": "VisualSearchIllustration-module__A2RoIq__photo",
  "scan": "VisualSearchIllustration-module__A2RoIq__scan",
  "stage": "VisualSearchIllustration-module__A2RoIq__stage",
});
